export const SINGLE = 'SINGLE';
export const MARRIED = 'MARRIED';
export const MARRIED_SINGLE = 'MARRIED_SINGLE';
export const MARRIED_PARTNER_UNEMPLOYED = 'MARRIED_PARTNER_UNEMPLOYED';
export const DIVORCED = 'DIVORCED';
export const WIDOWED = 'WIDOWED';
export const JUDICIALLY_SEPARATED = 'JUDICIALLY_SEPARATED';

export const MARITAL_STATUSES = [
  SINGLE,
  MARRIED,
  MARRIED_SINGLE,
  MARRIED_PARTNER_UNEMPLOYED,
  DIVORCED,
  WIDOWED,
  JUDICIALLY_SEPARATED,
]

export const MIN_DESIRED_LOAN = 1000;
export const MAX_DESIRED_LOAN = 250000;
export const MIN_DESIRED_RATE = 150;
export const MAX_DESIRED_RATE = 2500;

export const MIN_TIME = '08:00';
export const MID_DAY_TIME = '12:00';
export const MAX_TIME = '20:00';
export const MIN_TIME_NUMBER = 8;
export const MAX_TIME_NUMBER = 20;
export const MIN_DEFAULT_TIME_NUMBER = 8;
export const MAX_DEFAULT_TIME_NUMBER = 12;

export const PHONE_NUMBER_LENGTH = 12;

export const FIELD_DESIRED_LOAN = 'desiredLoan';
export const FIELD_DESIRED_RATE = 'desiredRate';
export const FIELD_FULL_NAME = 'fullName';
export const FIELD_PHONE = 'phone';
export const FIELD_EMAIL = 'email';
export const FIELD_DATE_OF_BIRTH = 'dateOfBirth';
export const FIELD_MARITAL_STATUS = 'maritalStatus';
export const FIELD_ZIP = 'zip';
export const FIELD_LOCATION = 'location';
export const FIELD_STREET = 'street';
export const FIELD_NUMBER = 'number';
export const FIELD_WORKDAY_AVAILABILITY = 'workdayAvailability';
export const FIELD_WORKDAY_FROM = 'workdayFrom';
export const FIELD_WORKDAY_TO = 'workdayTo';
export const FIELD_SATURDAY_FROM = 'saturdayFrom';
export const FIELD_SATURDAY_TO = 'saturdayTo';
export const FIELD_SATURDAY_AVAILABILITY = 'saturdayAvailability';
export const FIELD_SPOUSE_FULL_NAME = 'spouseFullName';
export const FIELD_SPOUSE_PHONE = 'spousePhone';
export const FIELD_SPOUSE_EMAIL = 'spouseEmail';
export const FIELD_SPOUSE_PRIVACY_POLICY = 'spousePrivacyPolicy';
export const FIELD_PRIVACY_POLICY = 'privacyPolicy';
export const FIELD_ADDRESS = 'address';

export const FIELD_TIME_TYPE = [FIELD_WORKDAY_AVAILABILITY, FIELD_SATURDAY_AVAILABILITY];

export const WORKDAY_TIME = {
  key: FIELD_WORKDAY_AVAILABILITY,
  label: 'reachable.workdays',
  fields: [FIELD_WORKDAY_FROM, FIELD_WORKDAY_TO]
};
export const SATURDAY_TIME = {
  key: FIELD_SATURDAY_AVAILABILITY,
  label: 'reachable.saturday',
  fields: [FIELD_SATURDAY_FROM, FIELD_SATURDAY_TO]
};
export const ADDRESS = {
  key: FIELD_ADDRESS,
  label: 'address',
  fields: [FIELD_ZIP, FIELD_LOCATION, FIELD_STREET, FIELD_NUMBER]
};

export const FORM_SECTION_DESIRED_LOAN = {
  title: 'section.desired.loan',
  fields: [FIELD_DESIRED_LOAN, FIELD_DESIRED_RATE]
};
export const FORM_SECTION_PERSONAL_INFORMATION = {
  title: 'section.information.personal',
  fields: [FIELD_FULL_NAME, FIELD_PHONE, FIELD_EMAIL, FIELD_DATE_OF_BIRTH, FIELD_MARITAL_STATUS]
};
export const FORM_SECTION_ADDRESS_CONTACT = {
  title: 'section.address.contact',
  fields: [ADDRESS, WORKDAY_TIME, SATURDAY_TIME]
};
export const FORM_SECTION_SPOUSE_INFORMATION = {
  title: 'section.information.spouse',
  fields: [FIELD_SPOUSE_FULL_NAME, FIELD_SPOUSE_PHONE, FIELD_SPOUSE_EMAIL, FIELD_SPOUSE_PRIVACY_POLICY]
};
export const FORM_SECTION_OTHER_INFORMATION = {
  title: 'section.information.other',
  fields: [FIELD_PRIVACY_POLICY]
};
export const FORM_SECTIONS = [
  FORM_SECTION_DESIRED_LOAN,
  FORM_SECTION_PERSONAL_INFORMATION,
  FORM_SECTION_ADDRESS_CONTACT,
  FORM_SECTION_SPOUSE_INFORMATION,
  FORM_SECTION_OTHER_INFORMATION,
]

export const FORM_SECTIONS_WRAPPER = [
  [FORM_SECTION_DESIRED_LOAN, FORM_SECTION_ADDRESS_CONTACT, FORM_SECTION_OTHER_INFORMATION],
  [FORM_SECTION_PERSONAL_INFORMATION, FORM_SECTION_SPOUSE_INFORMATION]
]